import { MapPin, Calendar } from "@phosphor-icons/react";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";

const API = process.env.REACT_APP_BACKEND_URL;
const MONTHS = ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export const fullUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${API}${u}`);

export const formatFrDate = (d) => {
  if (!d || !d.includes("-")) return d || "";
  const [y, m, day] = d.split("-");
  return `${parseInt(day, 10)} ${MONTHS[parseInt(m, 10)]} ${y}`;
};

const RealisationCard = ({ item }) => {
  const hasSlider = item.before_url && item.after_url;
  return (
    <article className="bg-[#EDEBE4] border border-[#1A1A1A]/5 overflow-hidden group" data-testid={`realisation-${item.id}`}>
      <div className="aspect-[4/3] overflow-hidden bg-[#1A1A1A]">
        {hasSlider ? (
          <BeforeAfterSlider before={fullUrl(item.before_url)} after={fullUrl(item.after_url)} alt={item.title}
            testId={`slider-${item.id}`} />
        ) : (
          <img src={fullUrl(item.image_url)} alt={item.title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        )}
      </div>
      <div className="p-5">
        <h3 className="text-[#1A1A1A] text-sm font-medium mb-2">{item.title}</h3>
        {item.description && <p className="text-[#1A1A1A]/60 text-xs leading-relaxed mb-3">{item.description}</p>}
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[#1A1A1A]/50 text-xs">
          <span className="flex items-center gap-1"><MapPin size={11} weight="fill" /> {item.city}{item.department ? `, ${item.department}` : ""}</span>
          <span className="flex items-center gap-1"><Calendar size={11} weight="fill" /> {formatFrDate(item.date)}</span>
        </div>
      </div>
    </article>
  );
};

export default RealisationCard;
